import React, { createContext, useContext, useState } from 'react';

const DebugContext = createContext();

const isDebugMode = () => import.meta.env.VITE_DEBUG_MODE === 'true';

export const useDebug = () => {
  const context = useContext(DebugContext);
  if (!context) throw new Error('useDebug must be used within DebugProvider');
  return context;
};

export const DebugProvider = ({ children }) => {
  const [logs, setLogs] = useState([]);

  const addLog = (type, message, data = null) => {
    const timestamp = new Date().toLocaleTimeString();
    setLogs(prev => [...prev, { id: Date.now(), type, message, data, timestamp }]);
  };

  const clearLogs = () => setLogs([]);

  const value = {
    debugMode: isDebugMode(),
    logs,
    addLog,
    clearLogs
  };

  return (
    <DebugContext.Provider value={value}>
      {children}
    </DebugContext.Provider>
  );
};
